import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ScopeProvider } from 'app/upgraded.providers';

@Directive({
  selector: 'app-login',
  providers: [ScopeProvider],
})
export class LoginUpgradeDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('loginDirective', elementRef, injector);
  }
}
